import { defineProviderCapability } from "./define-provider-capability";

// Mobile-only ad SDK config (AdMob app/unit IDs + VAST ad URLs). Values
// live in mobile/<env-instance> Doppler and get baked into the EAS build
// at preview-publish time, or read from mobile/local-<user> for local
// runs.
const mobileOnlyEnvironments = {
  local: { mode: "managed" },
  preview: { mode: "managed" },
  production: { mode: "managed" },
} as const;

const mobileDopplerEnv = (name: string) => ({
  name,
  availability: "boot" as const,
  source: {
    kind: "doppler" as const,
    project: "mobile",
    config: "environment" as const,
  },
  mobileEasArtifact: "eas-json" as const,
});

export const ads = defineProviderCapability("ads", {
  // AdMob app + ad-unit IDs for the mobile app.
  admob: {
    scope: "runtime",
    environments: mobileOnlyEnvironments,
    env: [
      mobileDopplerEnv("EXPO_PUBLIC_ADMOB_ANDROID_APP_ID"),
      mobileDopplerEnv("EXPO_PUBLIC_ADMOB_ANDROID_UNIT_ID"),
      mobileDopplerEnv("EXPO_PUBLIC_ADMOB_IOS_APP_ID"),
      mobileDopplerEnv("EXPO_PUBLIC_ADMOB_IOS_UNIT_ID"),
    ],
  },
  // VAST ad URLs (video advertising standard) consumed by the mobile player.
  vast: {
    scope: "runtime",
    environments: mobileOnlyEnvironments,
    env: [
      mobileDopplerEnv("EXPO_PUBLIC_VAST_ANDROID"),
      mobileDopplerEnv("EXPO_PUBLIC_VAST_IOS"),
    ],
  },
});
